import SectionHeading from "@/components/feature/SectionHeading";
import FeatureGrid from "@/components/feature/FeatureGrid";
import { siteKinds } from "@/mocks/criacao-sites";

export default function SiteKinds() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Tipos de site"
          badgeIcon="ri-layout-2-line"
          title="Sites para diferentes tipos de negócios"
          description="Do institucional à loja virtual, criamos a estrutura certa para o que a sua empresa precisa comunicar e vender."
        />
        <div className="mt-12">
          <FeatureGrid items={siteKinds} columns={3} accent="primary" />
        </div>
      </div>
    </section>
  );
}